import { render } from "./ChangeTraitModal.vue?vue&type=template&id=127ea41c&scoped=true"
import script from "./ChangeTraitModal.vue?vue&type=script&lang=js"
export * from "./ChangeTraitModal.vue?vue&type=script&lang=js"

import "./ChangeTraitModal.vue?vue&type=style&index=0&id=127ea41c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127ea41c"]])

export default __exports__